// extracted by mini-css-extract-plugin
export default {"wrap":"globalStyle_wrap__zlfHQ","container":"globalStyle_container__opX35"};